import type { CustomTheme } from '../../types';

const darkTheme: CustomTheme = {
  '--pcm-overlay-background': 'rgba(0,0,0,0.4)',
  '--pcm-modal-box-shadow': '0px 6px 20px 6px rgba(0, 0, 0, 0.1)',
  '--pcm-body-background': '#1C1D22',
  '--pcm-body-background-secondary': '#41424A',
  '--pcm-body-background-tertiary': '#232529',

  '--pcm-body-color': '#ffffff',
  '--pcm-body-color-secondary': '#8B8EA1',
  '--pcm-body-color-tertiary': '#42444B',

  '--pcm-body-action-color': '#808080',
  '--pcm-button-border-color': '#292B36',
  '--pcm-accent-color': '#A257FA',

  // button
  '--pcm-button-font-weight': '500',
  '--pcm-button-hover-shadow': '0px 2px 4px rgba(255, 255, 255, 0.05)',

  //primary button
  '--pcm-primary-button-color': '#000000',
  '--pcm-primary-button-bankground': '#FFFFFF',
  '--pcm-primary-button-hover-background': '#f5f5f5',

  // secondary button
  '--pcm-secondary-button-color': '#FFFFFF',
  '--pcm-secondary-button-bankground': '#41424A',
  '--pcm-secondary-button-hover-background': '#5A5B66',
};

export default darkTheme;
